import React from 'react';
import styled from 'styled-components';
import { Spacing } from '../../constants';
import { IcSuccess } from '../../icons';
import { Box } from '../Box';
import { Button as FztButton } from '../Button';
import { Text } from '../Text';
import Modal from './Modal';

interface SuccessModalProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  labelCancel?: string;
  labelConfirm?: string;
  onConfirm: () => void;
}

const ButtonGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  flex: 1;
  gap: ${Spacing[8]};
`;

const Button = styled(FztButton)`
  flex: 1;
`;

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  title = 'Application Submitted',
  description = 'Your application has been successfully submitted and waiting review.',
  labelConfirm = 'OK',
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} title={title} closeOnClickOutside={false} width={345} footer={null}>
      <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center' padding={24} gap={24}>
        <Box display='flex' flexDirection='column' alignItems='center' gap={16}>
          <IcSuccess />
          <Box display='flex' flexDirection='column' gap={8}>
            <Text title_h9 semibold center>
              {title}
            </Text>
            <Text body_1 regular center>
              {description}
            </Text>
          </Box>
        </Box>
        <ButtonGroup>
          <Button type_primary onClick={onConfirm} style={{ width: '100%' }}>
            {labelConfirm}
          </Button>
        </ButtonGroup>
      </Box>
    </Modal>
  );
};

export default SuccessModal;
